import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    marginTop: theme.spacing(2.75),
    marginBottom: theme.spacing(3.5),
    borderRadius: theme.spacing(0.5),
  },
}));

export const InfoBox = ({ color, children, style }) => {
  const classes = useStyles();

  return (
    <div style={{ backgroundColor: color, ...style }} className={classes.root}>
      {children}
    </div>
  );
};
